import React from 'react';
import { useModalState } from '../../../hooks/useModalState.ts';
import { useProductLeverage } from '../../../hooks/useProductLeverage.ts';
import { ProductType } from '../../../hooks/useProducts.ts';
import { crossMarginTooltip } from '../../../lib/tooltips';
import { Button } from '../../catalyst-ui-kit/button/index.ts';
import { Tooltip } from '../../Tooltip/Tooltip.tsx';

type TradeFormHeaderUiProps = {
  product: ProductType;
};

export const TradeFormHeader: React.FC<TradeFormHeaderUiProps> = ({ product }) => {
  const { value: leverage } = useProductLeverage(product);
  const setLeverageModal = useModalState((state) => state.setLeverageModal);

  return (
    <div className="flex items-center justify-between p-3 text-xs font-normal">
      <p className="hidden text-xs font-medium lg:block">Trade</p>
      <div className="space-x-1">
        <Tooltip content={crossMarginTooltip()}>
          <Button disabled size="xs" className="font-normal">
            Cross
          </Button>
        </Tooltip>
        <Button
          size="xs"
          className="font-normal !text-contentBlue"
          onClick={() => setLeverageModal('open')}
        >
          {leverage}x
        </Button>
      </div>
    </div>
  );
};
